import { Component } from '@angular/core';

@Component({
  templateUrl: './list-box.html'  
})
export class ListBoxComponent { 

    constructor() {
      this.ItemsSource = 
      [
        { Name:'Apple' },
        { Name:'Banana' },
        { Name:'Cherry' },
        { Name:'Orange' },
        { Name:'Pineapple' },        
        { Name:'Strawberry' },
        { Name:'Tomato' },        
        { Name:'Watermelon' },
        { Name:'Yam' },
        { Name:'Zucchini' },
      ];
    }

    public ItemsSource;
    public ListBoxSelectedItem;    
    public CheckBoxSelectedItem;
    ListBoxSelectedItemName: string;
  
    public IsSelected(item: any) {
      return item == this.CheckBoxSelectedItem;
    }

    public BackgroundColor(item: any) {
      if (item && item.Name) {

        switch (item.Name) {
          case 'Apple': return "chartreuse";
          case 'Banana': return "yellow";
          case 'Cherry': return "red";
          case 'Orange': return "orange";
          case 'Pineapple': return "darkgoldenrod";
          case 'Strawberry': return "violet";
          case 'Tomato': return "tomato";
          case 'Watermelon': return "lightgreen";
          case 'Yam': return "tan";
          case 'Zucchini': return "limegreen";
        }
      }
      return;
    }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/list-box/list-box-component.ts